import { render, staticRenderFns } from "./modalAddRevenueCenter.vue?vue&type=template&id=2f24a3ee"
import script from "./modalAddRevenueCenter.vue?vue&type=script&lang=js"
export * from "./modalAddRevenueCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports